import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Car } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AffiliateLogin = () => {
  const navigate = useNavigate();
  const { loginAfiliat, loginAdmin, afiliatToken, adminToken, userRole } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "", parola: "" });

  useEffect(() => {
    // Redirect based on stored role, not just token presence
    if (adminToken && userRole === "admin") {
      navigate("/admin/dashboard");
    } else if (adminToken && userRole === "consilier") {
      navigate("/consilier/dashboard");
    } else if (afiliatToken) {
      navigate("/affiliate/dashboard");
    }
  }, [afiliatToken, adminToken, userRole, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, form);
      const { role, token, user } = res.data;
      
      if (role === "admin") {
        loginAdmin(token, "admin");
        toast.success("Bine ai venit, Admin!");
        navigate("/admin/dashboard");
      } else if (role === "consilier") {
        loginAdmin(token, "consilier"); // consilier uses admin token storage with role
        toast.success(`Bine ai venit, ${user.nume}!`);
        navigate("/consilier/dashboard");
      } else {
        loginAfiliat(token, { ...user, role: "afiliat" });
        toast.success("Bine ai venit!");
        navigate("/affiliate/dashboard");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Email sau parola incorecta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="flex justify-center mb-6">
            <Link to="/" className="flex items-center gap-2">
              <div className="w-12 h-12 bg-emerald-500 rounded-xl flex items-center justify-center">
                <Car className="w-7 h-7 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-xl text-gray-900 leading-tight">AUTO PRO</span>
                <span className="text-xs text-emerald-600 font-medium -mt-1">DAUNE</span>
              </div>
            </Link>
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2 text-center">Autentificare</h1>
          <p className="text-gray-500 text-center mb-8">Conecteaza-te la contul tau</p>
          <form onSubmit={handleSubmit} className="space-y-4">
            <input type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-transparent" required data-testid="login-email" />
            <input type="password" placeholder="Parola" value={form.parola} onChange={e => setForm({...form, parola: e.target.value})} className="w-full px-4 py-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-transparent" required data-testid="login-password" />
            <button type="submit" disabled={loading} className="w-full py-3 bg-emerald-500 text-white rounded-xl hover:bg-emerald-600 disabled:bg-emerald-300 font-medium" data-testid="login-submit">
              {loading ? "Se conecteaza..." : "Conectare"}
            </button>
          </form>
          <p className="text-sm text-gray-500 mt-6 text-center">
            Esti afiliat nou? <Link to="/affiliate/register" className="text-emerald-600 hover:underline">Creeaza cont</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AffiliateLogin;
